import Avatar from '@material-ui/core/Avatar';
import Box from '@mui/material/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { getFirst, POST } from 'clients/Clients';
import clsx from 'clsx';
import LinkComp from 'components/atoms/LinkComp';
import { THUOCSI_LABEL } from 'constants/Enums';
import { ICON_CHAT_NGAY, ICON_STORE } from 'constants/Icons';
import { STORE_IMAGE_DEFAULT } from 'constants/Images';
import { LOGO_MEDX } from 'constants/Images/default';
import { useConfigHangDiem } from 'hooks/useConfigHangDiem';
import { useEffect, useState } from 'react';
import { DOMAIN_SELLER_CENTER } from 'sysconfig';
import { ImageFallbackStatic, ImageFallbackStoreImage } from 'utils/ImageFallback';
import { getLinkProxyFile } from 'utils/ImageUtils';
import styles from './styles.module.css';

const OtherInfoSeller = ({ product, fullName, seller, avatar, isStore, isInternal, isDisplayStore, linkSeller, linkStore, isVip }) => {
  const { code, vendorSellerCode } = seller;
  const isShowBtnChat = isStore && !isInternal;
  const [conversationSellerInfo, setConversationSellerInfo] = useState({});
  const { isHangDiem = false, config: configHangDiem } = useConfigHangDiem({ vendorInfoSellerCode: vendorSellerCode });

  useEffect(() => {
    const checkValidSeller = async () => {
      const resp = await POST({
        url: `/integration/chat/v1/proxy/seller/detail`,
        body: { code },
      });

      if (resp?.status === 'OK') {
        setConversationSellerInfo(getFirst(resp));
      }
    };

    checkValidSeller();
  }, []);

  const renderTitle = () => {
    if (isVip) {
      return <span className={styles.typography}>Gian hàng hãng</span>;
    }
    return <span className={styles.storeTag}>{THUOCSI_LABEL}</span>;
  };
  if (product?.vendorInfo && Object.keys(product.vendorInfo).length > 0) {
    const { primaryColor } = product.vendorInfo;

    return (
      <div className={clsx(styles.gridContainer, product?.sellerInfo?.description && styles.haveDescription)}>
        <Grid item xs={isHangDiem ? 4 : 3}>
          <div className={styles.wrapperLeft}>
            <Avatar src={getLinkProxyFile(product.vendorInfo.logo[0])} className={styles.avatar} style={{ border: `1px solid ${primaryColor}` }} />
            {(product.vendorInfo || isStore) && (
              <>
                {isHangDiem ? (
                  <span className={clsx(styles.typography, "!left-1/2  -translate-x-1/2")} style={configHangDiem?.badge?.styles}>{configHangDiem?.badge?.text}</span>
                ) : (
                  <span className={styles.typography} style={{ backgroundColor: primaryColor }}>
                    Gian hàng hãng
                  </span>
                )}
              </>
            )}
          </div>
        </Grid>
        <Grid item xs={isHangDiem ? 8 : 9} className={styles.rightContent}>
          <Typography className={styles.nameSeller}> {product.vendorInfo.name || ''}</Typography>
          {product?.vendorInfo?.numberProducts ? (
            <Typography className={styles.countProduct}>
              <span className={styles.nameSeller}>{product?.vendorInfo?.numberProducts}</span> <span className={styles.productTitle}>sản phẩm</span>
            </Typography>
          ) : null}
          <div className={styles.groupButton}>
            <Button className={clsx(styles.viewStore, styles.button)} variant="contained">
              <LinkComp href={product.vendorInfo.url}>
                <ImageFallbackStoreImage src={ICON_STORE} width={14} height={14} alt={fullName} />
                <span className={clsx(styles.text, styles.gotoStore)}>Xem Store</span>
              </LinkComp>
            </Button>
            {isShowBtnChat && conversationSellerInfo?._allowUseBuymedChat && (
              <Button
                className={clsx(styles.quickChat, styles.button)}
                onClick={() => {
                  if (window?.openBuyerChat) window?.openBuyerChat({ sellerCode: code });
                }}
                variant="contained"
              >
                <ImageFallbackStatic src={`${ICON_CHAT_NGAY}?size=origin`} width={14} height={14} alt="" />
                <span className={styles.text}>Chat ngay</span>
              </Button>
            )}
          </div>
        </Grid>
      </div>
    );
  }
  return (
    <>
      {code && fullName ? (
        <div className={clsx(styles.gridContainer, !isStore && styles.notGap, fullName === 'MEDX' && styles.medX)}>
          <Grid item xs={3} className={styles.store}>
            {fullName === 'MEDX' ? (
              <div className={styles.wrapperLeft}>
                <div className={styles.sellerIcon}>
                  <ImageFallbackStoreImage
                    src={LOGO_MEDX}
                    fallbackSrc={LOGO_MEDX}
                    width={65}
                    height={65}
                    q={100}
                    objectFit="contain"
                    alt="logo thuocsi"
                  />
                </div>
                {(product.vendorInfo || isStore) && <span className={clsx(styles.typography)}>Gian hàng hãng</span>}
              </div>
            ) : (
              <div className={clsx(styles.wrapperLeft)}>
                <Avatar className={clsx(styles.avatar)} alt={fullName} src={getLinkProxyFile(avatar[0]) || STORE_IMAGE_DEFAULT} />
                {(product.vendorInfo || isStore) && renderTitle()}
              </div>
            )}
          </Grid>
          <Grid item xs={9} className={styles.rightContent}>
            <Typography className={styles.nameSeller}> {fullName || ''}</Typography>
            {product?.sellerInfo?.numberProducts ? (
              <Typography className={styles.countProduct}>
                <span className={styles.nameSeller}>{product?.sellerInfo?.numberProducts}</span> <span className={styles.productTitle}>sản phẩm</span>
              </Typography>
            ) : null}
            <div className={styles.groupButton}>
              {isStore ? (
                <Button className={clsx(styles.viewStore, styles.button)} variant="contained">
                  <LinkComp href={linkStore}>
                    <ImageFallbackStoreImage src={ICON_STORE} width={14} height={14} alt={fullName} />
                    <span className={clsx(styles.text, styles.gotoStore)}>Xem Store</span>
                  </LinkComp>
                </Button>
              ) : (
                <>
                  {isDisplayStore && (
                    <Button className={clsx(styles.viewStore, styles.button)} variant="contained">
                      <LinkComp href={linkSeller}>
                        <ImageFallbackStoreImage src={ICON_STORE} width={14} height={14} alt={fullName} />
                        <span className={clsx(styles.text, styles.gotoStore)}>Xem Store</span>
                      </LinkComp>
                    </Button>
                  )}
                </>
              )}

              {isShowBtnChat && conversationSellerInfo?._allowUseBuymedChat && (
                <Button
                  className={clsx(styles.quickChat, styles.button)}
                  onClick={() => {
                    if (window?.openBuyerChat) window?.openBuyerChat({ sellerCode: code });
                  }}
                  variant="contained"
                >
                  <ImageFallbackStatic src={`${ICON_CHAT_NGAY}?size=origin`} width={14} height={14} alt="" />
                  <span className={styles.text}>Chat ngay</span>
                </Button>
              )}
            </div>
          </Grid>
        </div>
      ) : (
        <Box className={styles.bottom1}>
          <Typography variant="h4">Đăng ký bán hàng cùng thuocsi.vn.</Typography>
          <a href={DOMAIN_SELLER_CENTER}>Đăng ký</a>
        </Box>
      )}
    </>
  );
};

export default OtherInfoSeller;
